import React from 'react';
import { iconInfoEmpty } from '~utils/svgIcons';
import { connect } from 'react-redux';
import Button from '~components/button';
import { logout } from '~redux_related/user/actionCreators';
import './style.scss';

function Warning({ logout, isMobile }) {
    return (
        <div className="blocked-warning">
            <div className="blocked-warning__inner">
                {iconInfoEmpty}
                <div className="blocked-warning__message">
                    <h5 className="blocked-warning__title">Доступ к сайту ограничен</h5>
                </div>
            </div>
            <Button onClick={logout} size={isMobile ? 'small' : 'big'} ariaLabel="Выйти из аккаунта">
                Выйти из аккаунта
            </Button>
        </div>
    );
}

const mapStateToProps = (state) => ({
    isMobile: state.ui.device === 'mobile',
});

const mapDispatchToProps = (dispatch) => ({
    logout: () => dispatch(logout()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Warning);
export { Warning };



// WEBPACK FOOTER //
// ./src/routes/blocked-page/warning/index.js